//
// Scale widget
// ------------

/**
 *  Use this widget for auto-scaling items inside container
 *
 *  +-----------------------------------+
 *  |  $container                       |
 *  |  +-------------+ +-------------+  |
 *  |  | scale-group | | scale-group |  |
 *  |  |      1      | |      1      |  |
 *  |  |             | |             |  |
 *  |  |    $item    | |    $item    |  |
 *  |  +-------------+ +-------------+  |
 *  |                                   |
 *  +-----------------------------------+
 *
 *   Add `.fn-resize-container` class for container
 *   Add `.fn-resize-item` class for each item
 *   Add data-resize-group=* for items with distinct name for each group
 *   A group with name "0" is used as basis
 *   Attach widget on container
 */

define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var core = require('core');
    var _ = require('underscore');
    require('common/jbone.widget');

    var BASE_GROUP_NAME = '0';

    module.exports = $.widget('scale', {

        init: function() {
            var resizeGroups = this._getResizeGroups();
            var baseGroup = resizeGroups[BASE_GROUP_NAME];
            var baseItem = baseGroup[0];

            if (!baseItem) {
                return core.error('Scalable elements is not found');
            }

            this.container = this.el;

            var containerStyle = window.getComputedStyle(this.container);
            var baseItemStyle = window.getComputedStyle(baseItem);

            this.initialData = {
                containerDimensions: {
                    paddingLeft: parseFloat(containerStyle.paddingLeft),
                    paddingRight: parseFloat(containerStyle.paddingRight)
                },
                baseItemDimensions: {
                    height: baseItem.offsetHeight,
                    width: baseItem.offsetWidth,
                    marginLeft: parseFloat(baseItemStyle.marginLeft),
                    marginRight: parseFloat(baseItemStyle.marginRight)
                },
                resizeItemsDimensions: _.mapObject(resizeGroups, function(group) {
                    return {
                        height: group[0].offsetHeight,
                        width: group[0].offsetWidth
                    };
                })
            };
            this.resizeGroups = resizeGroups;

            // Do scaling
            this.scale();
        },

        /**
         * Get all resize groups in correct format
         * @private
         * @return {Object}
         */
        _getResizeGroups: function() {
            var items = this.el.querySelectorAll('.fn-resize-item');

            return _.chain(items)
                .groupBy(function(item) {
                    return item.dataset.resizeGroup;
                })
                .value();
        },

        _getScaleFactor: function() {
            var initialData = this.initialData;
            var containerDimensions = initialData.containerDimensions;
            var containerWithoutOffsets = parseInt(window.getComputedStyle(this.container).width)
                - containerDimensions.paddingLeft
                - containerDimensions.paddingRight;
            var baseItem = initialData.baseItemDimensions;
            var itemMarginsSize = baseItem.marginLeft + baseItem.marginRight;

            var itemsPerRow = this.options.itemsPerRow ||
                Math.floor(containerWithoutOffsets / (baseItem.width + itemMarginsSize));
            var itemWidth = Math.floor(containerWithoutOffsets / itemsPerRow) - itemMarginsSize;

            return itemWidth / baseItem.width;
        },

        /**
         * Scale resize groups
         */
        scale: function() {
            var initialData = this.initialData;

            if (!initialData) {
                return core.error('Scalable elements is not found');
            }

            var scaleFactor = this._getScaleFactor();

            _.each(this.resizeGroups, function(group, key) {
                var itemWidth = Math.floor(initialData.resizeItemsDimensions[key].width * scaleFactor);
                var itemHeight = Math.floor(initialData.resizeItemsDimensions[key].height * scaleFactor);

                _.each(group, function(el) {
                    el.style.width = itemWidth + 'px';
                    el.style.height = itemHeight + 'px';
                });
            });
        }

    });
});
